import saveReducer from "./saveReducer";
import { combineReducers } from "redux";
import surveyReducer from "./surveyReducer";
import campaignReducer from "./campaignReducer";
import userReducer from "./userReducer";
import genericSurveyReducer from "./genericSurveyReducer";
import filterReducer from "./filterReducer";
import subTierSurveyReducer from "./subTierSurveyReducer";
import validatorReducer from './validationReducer'
import surveyPartReducer from './surveyPartReducer'

const reducers = combineReducers({
  save: saveReducer,
  survey: surveyReducer,
  campaign: campaignReducer,
  currentUser: userReducer,
  genericSurvey: genericSurveyReducer,
  filter: filterReducer,
  subTierSurvey: subTierSurveyReducer,
  validator:validatorReducer,
  surveyPartReducer:surveyPartReducer
});

export default reducers;
